import { scroller } from "react-scroll";
import { isBrowser } from "../environmentDetection/library";

const hasDocument = () => {
    return typeof document === "object";
};

/**
 * For the given selector, focus on the element that is found
 * @param {*} selector - selector text for querySelector
 * @returns
 */
export function shiftFocusSafely(selector) {
    if (!isBrowser() || !hasDocument()) {
        return;
    }

    const element = document.querySelector(selector);
    if (element) element.focus();
}

/**
 * Scroll to section provided
 * @param {string} path - Section (must be an Element name)
 * @returns {void}
 */
export function scrollTo(element, e, domElementFocus) {
    if (!hasDocument() || !domElementFocus) return;

    e && e.preventDefault();

    scroller.scrollTo(element, {
        duration: 500,
        delay: 50,
        smooth: true,
        offset: -75,
    });

    const domElement = document.querySelector(domElementFocus);
    if (domElement) domElement.focus();
}
